import React from 'react';

export const getBankFallbackBrand = (name) => {
  const n = name ? name.toLowerCase() : '';
  if (n.includes('chase')) return { color: '#1152cd' };
  if (n.includes('bank of america') || n.includes('bofa')) return { color: '#dc3545' };
  if (n.includes('wells fargo')) return { color: '#d11210' };
  if (n.includes('citi') || n.includes('citibank')) return { color: '#004b87' };
  if (n.includes('capital one')) return { color: '#002a54' };
  if (n.includes('fidelity')) return { color: '#3b7c00' };
  return { color: '#6c757d' }; // Generic gray
};

export const ChaseIcon = ({ size = '24px' }) => (
  <svg 
    role="img" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size, fill: '#1152cd' }}
  >
    <title>Chase</title>
    <path d="M0 15.415c0 .468.38.85.848.85h5.937V.575L0 7.72v7.695m15.416 8.582c.467 0 .846-.38.846-.849v-5.937H.573l7.146 6.785h7.697M24 8.587a.844.844 0 0 0-.847-.846h-5.938V23.43l6.782-7.148L24 8.586M8.585.003a.847.847 0 0 0-.847.847v5.94h15.688L16.282.003H8.585Z"/>
  </svg>
);

export const BankOfAmericaIcon = ({ size = '24px' }) => (
  <svg 
    role="img" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size, fill: '#dc3545' }}
  >
    <title>Bank of America</title>
    <path d="M15.194 7.57c.487-.163 1.047-.307 1.534-.451-1.408-.596-3.176-1.227-4.764-1.625-.253.073-1.01.271-1.534.434.541.162 2.328.577 4.764 1.642zm-8.896 6.785c.577.343 1.19.812 1.786 1.209 3.952-3.068 7.85-5.432 12.127-6.767-.596-.307-1.119-.578-1.787-.902-2.562.65-6.947 2.4-12.126 6.46zm-.758-6.46c-2.112.974-4.331 2.31-5.54 3.085.433.199.866.361 1.461.65 2.671-1.805 4.764-2.905 5.594-3.266-.595-.217-1.154-.361-1.515-.47zm8.066.234c-.686-.379-3.068-1.263-4.71-1.642-.487.18-1.173.451-1.642.65.595.162 2.815.758 4.71 1.714.487-.235 1.173-.523 1.642-.722zm-3.374 1.552c-.56-.27-1.173-.523-1.643-.74-1.425.704-3.284 1.769-5.63 3.447.505.27 1.047.595 1.624.92 1.805-1.335 3.627-2.598 5.649-3.627zm1.732 8.825c3.79-3.249 9.113-6.407 12.036-7.544a48.018 48.018 0 00-1.949-1.155c-3.771 1.246-8.174 4.007-12.108 7.129.667.505 1.371 1.028 2.02 1.57zm2.851-.235h-.108l-.18-.27h-.109v.27h-.072v-.596h.27c.055 0 .109 0 .145.036.054.019.072.073.072.127 0 .108-.09.162-.198.162zm-.289-.343c.09 0 .199.018.199-.09 0-.072-.072-.09-.144-.09h-.163v.18zm-.523.036c0-.289.235-.523.541-.523.307 0 .542.234.542.523a.543.543 0 01-.542.542.532.532 0 01-.54-.542m.107 0c0 .235.199.433.451.433a.424.424 0 100-.848c-.27 0-.45.199-.45.415"/>
  </svg>
);

export const WellsFargoIcon = ({ size = '24px' }) => (
  <svg 
    role="img" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size, fill: '#d11210' }}
  >
    <title>Wells Fargo</title>
    <path d="M12.136 13.949c0 .392-.245.616-.719.616h-.628v-1.226h.628c.48 0 .72.212.72.61zM6.922 15.06h1.044l-.523-1.443-.521 1.443zm12.46-1.82c-.72 0-1.109.562-1.109 1.526 0 .97.384 1.526 1.108 1.526.725 0 1.108-.556 1.108-1.526 0-.964-.389-1.526-1.108-1.526zM23.73 0v24H.269V0h23.462zm-5.548 10.652c.484.245.948.354 1.571.354.895 0 1.481-.458 1.481-1.171 0-.6-.357-1.014-1.028-1.172l-.677-.158c-.394-.092-.559-.25-.559-.517 0-.322.25-.523.74-.523s.778.18.89.604l.048.186h.383v-.943a2.927 2.927 0 0 0-1.352-.338c-.911 0-1.497.447-1.497 1.166 0 .556.34.965.996 1.112l.676.152c.432.099.592.273.592.562 0 .354-.261.55-.784.55-.59 0-.894-.24-1.027-.697l-.07-.235h-.383v1.068zm-3.378.245h3.02V9.595h-.383l-.043.19c-.106.486-.255.638-.607.638h-.74V7.557h.506v-.474h-1.753v.474h.453v2.866h-.453v.474zm-3.355 0h3.02V9.595h-.384l-.042.19c-.107.486-.256.638-.608.638h-.74V7.557h.506v-.474H11.45v.474h.452v2.866h-.452v.474zm-8.758-3.34.938 3.34h.74l.778-2.768.756 2.768h.74l.932-3.34h.736v2.866h-.453v.474h3.201V9.595h-.383l-.043.19c-.106.486-.26.638-.607.638h-.922V9.241h1.071a.58.58 0 0 0 .059-.273.55.55 0 0 0-.059-.26h-1.07v-1.15h.884c.357 0 .48.157.596.615l.038.147h.383V7.083H6.49v.474h.522l-.613 2.305-.762-2.779h-.766l-.746 2.774-.624-2.3h.501v-.474H2.266v.474h.426zm1.412 7.002v-1.22h.947c.358 0 .48.158.597.615l.038.147h.383v-1.236H2.857v.474h.453v2.866h-.453v.474h1.78v-.474h-.533v-1.112H5.2a.58.58 0 0 0 .058-.272.551.551 0 0 0-.058-.262H4.104zm9.114 1.913a.461.461 0 0 0-.048-.224.663.663 0 0 1-.112.011c-.245 0-.309-.142-.34-.458l-.022-.201c-.048-.43-.245-.708-.73-.746v-.017c.48-.022.975-.349.975-.964 0-.621-.496-1.008-1.257-1.008H9.542v.474h.453v2.866H9.26l-1.332-3.34H7.22l-1.305 3.34h-.373v.474h1.412v-.474h-.448l.245-.682h1.385l.245.682h-.437v.474h3.35v-.474h-.505v-1.16h.293c.586 0 .761.212.826.762l.02.19c.06.507.31.725.826.725.15 0 .299-.01.416-.027a.46.46 0 0 0 .048-.223zm3.633-1.788h-1.417a.52.52 0 0 0-.059.256c0 .11.016.18.059.268h.634v.964a1.598 1.598 0 0 1-.629.125c-.767 0-1.166-.56-1.166-1.53s.4-1.532 1.124-1.532c.485 0 .767.245.932.67l.058.153h.384v-.976a3.063 3.063 0 0 0-1.412-.337c-1.172 0-1.96.8-1.96 2.027 0 1.231.767 2.016 1.96 2.016.474 0 .964-.136 1.492-.404v-1.7zm4.512.082c0-1.182-.831-2.021-1.982-2.021-1.145 0-1.981.839-1.981 2.021 0 1.188.83 2.022 1.981 2.022 1.156 0 1.982-.834 1.982-2.022z"/>
  </svg>
);

export const CitibankIcon = ({ size = '28px' }) => (
  <svg 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size }}
  >
    <path 
      d="M3 12.5C7 8.5 15 8.5 19 12.5" 
      stroke="#ed1c24" 
      strokeWidth="2" 
      fill="none" 
      strokeLinecap="round"
    />
    <text 
      x="11" 
      y="18" 
      fontFamily="'Inter', 'Arial', sans-serif" 
      fontWeight="bold" 
      fontSize="8.5" 
      fill="#002d72" 
      textAnchor="middle"
    >
      citi
    </text>
  </svg>
);

const BankIcon = ({ institutionName, logo, size = '48px' }) => {
  const name = institutionName || '';
  const fallback = getBankFallbackBrand(name);
  const isChase = name.toLowerCase().includes('chase');
  const isBofA = name.toLowerCase().includes('bank of america') || name.toLowerCase().includes('bofa');
  const isWells = name.toLowerCase().includes('wells fargo');
  const isCiti = name.toLowerCase().includes('citi') || name.toLowerCase().includes('citibank');

  if (logo) {
    return (
      <img 
        src={`data:image/png;base64,${logo}`} 
        alt={name} 
        style={{ 
          width: size, 
          height: size, 
          minWidth: size, 
          borderRadius: '50%', 
          objectFit: 'contain', 
          border: '1px solid #e9ecef', 
          padding: '4px', 
          backgroundColor: '#fff' 
        }} 
      />
    );
  }

  const containerStyle = {
    width: size,
    height: size,
    minWidth: size,
    backgroundColor: '#fff',
    border: '1px solid #e9ecef',
    boxShadow: `0 4px 10px ${fallback.color}15`
  };

  if (isChase) {
    return (
      <div className="d-flex align-items-center justify-content-center rounded-circle" style={containerStyle}>
        <ChaseIcon size={`calc(${size} * 0.5)`} />
      </div>
    );
  }
  if (isBofA) {
    return (
      <div className="d-flex align-items-center justify-content-center rounded-circle" style={containerStyle}>
        <BankOfAmericaIcon size={`calc(${size} * 0.5)`} />
      </div>
    );
  }
  if (isWells) {
    return (
      <div className="d-flex align-items-center justify-content-center rounded-circle" style={containerStyle}>
        <WellsFargoIcon size={`calc(${size} * 0.5)`} />
      </div>
    );
  }
  if (isCiti) {
    return (
      <div className="d-flex align-items-center justify-content-center rounded-circle" style={containerStyle}>
        <CitibankIcon size={`calc(${size} * 0.6)`} />
      </div>
    );
  }

  return (
    <div 
      className="d-flex align-items-center justify-content-center rounded-circle text-white font-weight-bold" 
      style={{ ...containerStyle, backgroundColor: fallback.color, fontSize: `calc(${size} * 0.4)` }}
    >
      {name.charAt(0).toUpperCase() || <i className="fas fa-university"></i>}
    </div>
  );
};

export default BankIcon;
